import { action, createRequestTypes } from '../base';

export const analyticsActionTypes = {
  GET_ANALYTICS_DATA: createRequestTypes('GET_ANALYTICS_DATA'),
  DOWNLOAD_DOCUMENT: createRequestTypes('DOWNLOAD_DOCUMENT'),
  GET_BULK_UPLOADS: createRequestTypes('GET_BULK_UPLOADS'),
  COMMON_GET_REQUEST: createRequestTypes('COMMON_GET_REQUEST'),
  PRINT_LABELS: createRequestTypes('PRINT_LABELS'),
};

/**
 * ActivityLogActions class
 */
class AnalyticsActions {
    /**
     *
     * @param dataType
     * @param name
     * @param params
     * @returns {{type: *}}
     */
    getAnalyticsData = (dataType, name, params) => action(analyticsActionTypes.GET_ANALYTICS_DATA.REQUEST, {
      dataType, name, params,
    });

    /**
     *
     * @param dataType
     * @param name
     * @param getAnalyticsDataLoading
     * @returns {{type: *}}
     */
    getAnalyticsDataLoading = (dataType, name, loading) => action(analyticsActionTypes.GET_ANALYTICS_DATA.LOADING, {
      dataType, name, loading,
    })

    /**
     *
     * @param dataType
     * @param name
     * @param data
     * @returns {{type: *}}
     */
    getAnalyticsDataSuccess = (dataType, name, data) => action(analyticsActionTypes.GET_ANALYTICS_DATA.SUCCESS, {
      dataType, name, data,
    })

    /**
     *
     * @param payload
     * @param callback
     * @returns {{type: *}}
     */
    downloadDocument = (payload, callback) => action(analyticsActionTypes.DOWNLOAD_DOCUMENT.REQUEST, {
      payload, callback,
    })

    downloadDocumentLoading = (payload) => action(analyticsActionTypes.DOWNLOAD_DOCUMENT.LOADING, {
      payload,
    })

    /**
     *
     * @param key
     * @returns {{type: *}}
     */
    downloadDocumentSuccess = (key) => action(analyticsActionTypes.DOWNLOAD_DOCUMENT.SUCCESS, {
      key,
    })

    // label download
    printLabels = (payload, callback) => action(analyticsActionTypes.PRINT_LABELS.REQUEST, {
      payload, callback,
    })

    printLabelsLoading = (printLabelsLoading) => action(analyticsActionTypes.PRINT_LABELS.LOADING, {
      printLabelsLoading,
    })

    printLabelsSuccess = (printedLabels) => action(analyticsActionTypes.PRINT_LABELS.SUCCESS, {
      printedLabels,
    })

    /**
     *
     * @param payload
     * @param callback
     * @returns {{type: *}}
     */
    getBulkUploads = (payload, callback) => action(analyticsActionTypes.GET_BULK_UPLOADS.REQUEST, {
      payload, callback,
    })

    /**
     *
     * @param getBulkUploadsLoading
     * @returns {{type: *}}
     */
    getBulkUploadsLoading = (getBulkUploadsLoading) => action(analyticsActionTypes.GET_BULK_UPLOADS.LOADING, {
      getBulkUploadsLoading,
    })

    /**
     *
     * @param bulkUploads
     * @returns {{type: *}}
     */
    getBulkUploadsSuccess = (bulkUploads) => action(analyticsActionTypes.GET_BULK_UPLOADS.SUCCESS, {
      bulkUploads,
    })
    
    commonGetRequests = (payload, callback) => action(analyticsActionTypes.COMMON_GET_REQUEST.REQUEST, {
      payload, callback,
    })

    commonGetRequestsLoading = (commonGetRequestsLoading) => action(analyticsActionTypes.COMMON_GET_REQUEST.LOADING, {
      commonGetRequestsLoading,
    })
}

export default new AnalyticsActions();
